<template>
	<div ref="zoneRef" class="appointment-pin-zone">
		<label v-if="context?.visible" class="appointment-pin-zone__card" :class="{ 'appointment-pin-zone__card--active': pinned }">
			<v-icon class="appointment-pin-zone__icon" size="20">keep</v-icon>
			<span class="appointment-pin-zone__text">
				<strong>{{ t('PinVisit') }}</strong>
				<span class="appointment-pin-zone__hint">{{ t('PinVisitHint') }}</span>
			</span>
			<v-switch :model-value="pinned" color="primary" density="compact" inset hide-details @update:model-value="toggle" />
		</label>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useTranslator } from '@/composables/useTranslator';
import { useAppointmentStore } from '@/stores/AppointmentStore';
import { toDayKey } from '@/utils/legacy/agendaRouteSource';
import { rerenderLegacyAgenda } from '@/utils/legacy/agendaWriter';

const t = useTranslator();
const store = useAppointmentStore();
const zoneRef = ref(null);
const context = ref(null);
let mountTarget = null;

const pinned = computed(() => store.isPinned(context.value?.uid));

function handleContext(event) {
	context.value = event?.detail ?? null;
}

function toggle(value) {
	const uid = context.value?.uid;
	if (!uid) return;
	store.setPinned(uid, context.value.start ? toDayKey(context.value.start) : toDayKey(Date.now()), !!value);
	rerenderLegacyAgenda();
}

onMounted(() => {
	mountTarget = zoneRef.value?.parentElement;
	mountTarget?.addEventListener('vue:appointment-pin-context', handleContext);
	if (mountTarget?._pendingPinContext) handleContext({ detail: mountTarget._pendingPinContext });
});

onBeforeUnmount(() => {
	mountTarget?.removeEventListener('vue:appointment-pin-context', handleContext);
	mountTarget = null;
});
</script>
